module.exports = __webpack_public_path__ + "assets/d6c99f2b19fc275dde8e8ac73d0edeca.mp3";